import apiService from '../Api'
import { SalaryRange } from '../JobApplication/types'

export class SalaryRangeService {
  async list(): Promise<SalaryRange[]> {
    return apiService.get('/salary-ranges').then((response) => response.data)
  }
}
